
import request from '@/utils/request';

export function getWxSdk() {
    return request('http://appwx.people.cn/static/peopletech/jssdk.php', {
        method: 'get',
        data: {
           url: encodeURIComponent(window.location.href.split('#')[0])
        }
    });
}

export function getApkLink() {
    return request('http://vweb.people.cn/prod/common/api/admin/api/version?pj_code=lucky_10_201803', {
        method: 'get'
    });
}

export function getDetail(params) {
    return request(`/detail/${params.id}`, {
        method: 'get'
    });
}



// WEBPACK FOOTER //
// ./src/service/server-api.js